import store from "@frameworks/web/redux/store";
import { ALLINDICES_LIST, ALLINDICES_LIST_ERROR, ALLINDICES_LIST_HIDE_ERROR, ALLINDICES_LIST_START_LOADER, ALLINDICES_LIST_STOP_LOADER, } from "../interface/IAllIndicesList";
class AllIndicesListActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getAllIndicesList(data) {
        this.dispatch({
            type: ALLINDICES_LIST,
            payload: { data },
        });
    }
    setError(payload) {
        this.dispatch({
            type: ALLINDICES_LIST_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError() {
        this.dispatch({
            type: ALLINDICES_LIST_HIDE_ERROR,
        });
    }
    startLoader() {
        this.dispatch({
            type: ALLINDICES_LIST_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: ALLINDICES_LIST_STOP_LOADER,
        });
    }
}
export default AllIndicesListActions;
